module.exports = __webpack_public_path__ + "media/club/thematic-recettes-ohra-67526356.webp";